import { render, staticRenderFns } from "./windows.vue?vue&type=template&id=265c1344"
import script from "./windows.vue?vue&type=script&lang=js"
export * from "./windows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports